import PropTypes from 'prop-types';

import useIsMobile from '@/src/hooks/useIsMobile';
import BackToList from '@/src/howTo/components/BackToList';
import Search from '@/src/howTo/components/search/Search';
import HowToSideBar from '@/src/howTo/components/sideBar/HowToSideBar.storyblok';
import {SectionContainer} from '@/src/ui';

import css from '../styles/HowToLayout.module.css';

const HowToLayout = ({
  children,
  onSearchChange,
  searchFoundedItems,
  sidebarStory,
  onSearchSubmit,
  withBackButton,
  title,
}) => {
  const {isMaxWidth1100} = useIsMobile();

  return (
    <div>
      <Search
        onSearchSubmit={onSearchSubmit}
        onChange={onSearchChange}
        foundedItems={searchFoundedItems}
        title={title}
      />
      <SectionContainer>
        <div className={css.sideBarAndContentView}>
          <div>
            <div className={css.sidebarWrapper}>
              {withBackButton && !isMaxWidth1100 && (
                <div className={css.back}>
                  <BackToList />
                </div>
              )}
              <HowToSideBar blok={sidebarStory} />
            </div>
          </div>
          <div className={css.contentWrapper}>{children}</div>
        </div>
      </SectionContainer>
    </div>
  );
};

HowToLayout.propTypes = {
  children: PropTypes.node.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  searchFoundedItems: PropTypes.array.isRequired,
  sidebarStory: PropTypes.object.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  withBackButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

HowToLayout.defaultProps = {
  withBackButton: false,
};

export default HowToLayout;
